import { DtoApiPager } from "./abst/DtoApiPager";
import { EntityStaff } from "../entity/EntityStaff";

export class DtoAuthenticationsGetRes extends EntityStaff {}
